import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { AgGrid } from '../../AgGrid';
import classnames from 'classnames';

// SERVICES
import { getUsers } from '../../../services';

const styles = theme => ({});

export const RestrictionsGrid = withStyles(styles)(props => {
  const [gridData, setGridData] = useState(null);

  const columnDefinitions = [
    { headerName: 'Name', field: 'name', width: 200 },
    { headerName: 'Username', field: 'userName', width: 250 },
    { headerName: 'E-mail', field: 'email', width: 250 },
    { headerName: 'Roles', field: 'roles', width: 150 },
    { headerName: 'Address', field: 'address', width: 250 },
    { headerName: 'City', field: 'city', width: 200 },
    { headerName: 'State', field: 'state', width: 150 },
    { headerName: 'Zip', field: 'zip', width: 150 },
  ];

  const gridOptions = {};

  const getUsersAsync = async () => {
    try {
      const data = await getUsers();
      setGridData(data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getUsersAsync();
  }, []);

  return (
    <div className={classnames('flex-1', 'col-center-center')}>
      <AgGrid
        gridData={gridData}
        gridOptions={gridOptions}
        columnDefs={columnDefinitions}
        showCreateButton={true}
        redirectOnClick={true}
        editOnClick={false}
      />
    </div>
  );
});
